import { render, staticRenderFns } from "./digitalTransformate.vue?vue&type=template&id=c898c018&scoped=true&"
import script from "./digitalTransformate.vue?vue&type=script&lang=js&"
export * from "./digitalTransformate.vue?vue&type=script&lang=js&"
import style0 from "./digitalTransformate.vue?vue&type=style&index=0&id=c898c018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c898c018",
  null
  
)

export default component.exports